import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18a6f070"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-players-profile-tips-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Savjeti ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdministratorPlayersProfileTipsListFormCreateIndexVue = _resolveComponent("AdministratorPlayersProfileTipsListFormCreateIndexVue")!
  const _component_AdministratorPlayersProfileTipsListFormUpdateIndexVue = _resolveComponent("AdministratorPlayersProfileTipsListFormUpdateIndexVue")!
  const _component_AdministratorPlayersProfileTipsListFormRemoveIndexVue = _resolveComponent("AdministratorPlayersProfileTipsListFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AdministratorPlayersProfileTipsListFormCreateIndexVue, { onGetTips: _ctx.getTips }, null, 8, ["onGetTips"])
      ]),
      (_ctx.tips.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tips, (tip, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: tip.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, " #" + _toDisplayString(key + 1) + " - " + _toDisplayString(_ctx.moment(tip.created_at).format('DD.MM.YYYY.')), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AdministratorPlayersProfileTipsListFormUpdateIndexVue, {
                    tip: tip,
                    onGetTips: _ctx.getTips
                  }, null, 8, ["tip", "onGetTips"]),
                  _createVNode(_component_AdministratorPlayersProfileTipsListFormRemoveIndexVue, {
                    tip: tip,
                    onGetTips: _ctx.getTips
                  }, null, 8, ["tip", "onGetTips"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, " Nema podataka... "))
    ])
  ]))
}